import { ILoggedInUser } from "../apis/auth/auth.interfaces";

export enum UserType {
  STANDARD = "standard",
  INSTITUTE_SCOPED = "institute-scoped",
}

export const isInstituteScopedUser = (user: ILoggedInUser | null): boolean => {
  if (!user) return false;
  return (
    user.userType === UserType.INSTITUTE_SCOPED ||
    user.type === UserType.INSTITUTE_SCOPED ||
    !!user.assignedInstituteId
  );
};

export const canAccessInstituteLevelPages = (
  user: ILoggedInUser | null,
): boolean => {
  return !isInstituteScopedUser(user);
};
